/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import { C11nEnv } from '../../interpreter/c11n-env';
import type { AIAgentCoachModel } from '../../rules/types';
import AnnotationsHandler from '..';
import * as RuleStore from '../../rules/rules-store';

AnnotationsHandler.registerHandler(
  '@GENAICOACH',
  (genAICoachName: string, c11nEnv: C11nEnv): AIAgentCoachModel | null =>
    RuleStore.getGenAICoach(genAICoachName, c11nEnv.getCurrentClassID())
);
